import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import styles from "./AdminDashboard.module.css";
import logo from "./optolog_logo.png";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";


function AdminDashboard() {
  const navigate = useNavigate();
  const user = auth.currentUser;
  const [cohort, setCohort] = useState("OD-1");
  const [monthlyData, setMonthlyData] = useState([]);
  const [stats, setStats] = useState({
    totalEncounters: 0,
    totalExposures: 0,
    totalHours: 0,
    ratio: 0,
  });

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };
  const getMonthYear = (dateStr) => {
  const date = new Date(dateStr);
  return `${date.toLocaleString("default", { month: "short" })} ${date.getFullYear()}`;
};


  useEffect(() => {
    const fetchStats = async () => {
      try {
        const logsRef = collection(db, "logs");
        const q = cohort === "All Cohorts"
          ? query(logsRef)
          : query(logsRef, where("cohort", "==", cohort));

        const snapshot = await getDocs(q);

        let totalEncounters = 0;
        let totalExposures = 0;
        let totalHours = 0;

        snapshot.forEach((doc) => {
          const data = doc.data();
          totalEncounters += data.involvementType === "Encounter" ? 1 : 0;
          totalExposures += data.involvementType === "Exposure" ? 1 : 0;
          totalHours += parseFloat(data.duration || 0);
        });

        const ratio = totalExposures === 0 ? totalEncounters : (totalEncounters / totalExposures).toFixed(2);

        setStats({
          totalEncounters,
          totalExposures,
          totalHours: totalHours.toFixed(1),
          ratio,
        });
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    fetchStats();
  }, [cohort]);

  return (
    <div className={styles.wrapper}>
      {/* 🔵 Top Bar */}
      <div className={styles.topBar}>
  <img src={logo} alt="OptoLog Logo" className={styles.logo} />

  <div className={styles.schoolName}>
    Rocky Mountain University - College of Optometric Medicine
  </div>

  <div className={styles.rightSection}>
    <span className={styles.userInfo}>
      {user?.email || "Admin"}
    </span>
    <button onClick={handleLogout} className={styles.logoutButton}>
      Log Out
    </button>
  </div>
</div>


      {/* 🔽 Cohort Selector */}
      <div className={styles.cohortSelectContainer}>
        <label htmlFor="cohort">Select Cohort:</label>
        <select
          id="cohort"
          value={cohort}
          onChange={(e) => setCohort(e.target.value)}
          className={styles.selectDropdown}
        >
          <option value="OD-1">OD-1</option>
          <option value="OD-2">OD-2</option>
          <option value="OD-3">OD-3</option>
          <option value="OD-4">OD-4</option>
          <option value="All Cohorts">All Cohorts</option>
        </select>
      </div>

      {/* 📊 Summary Stats */}
      <div className={styles.summaryGrid}>
        <div className={styles.summaryBox}>
          <h3>Total Encounters</h3>
          <p>{stats.totalEncounters}</p>
        </div>
        <div className={styles.summaryBox}>
          <h3>Total Exposures</h3>
          <p>{stats.totalExposures}</p>
        </div>
        <div className={styles.summaryBox}>
          <h3>Enc/Exp Ratio</h3>
          <p>{stats.ratio}</p>
        </div>
        <div className={styles.summaryBox}>
          <h3>Total Hours</h3>
          <p>{stats.totalHours}</p>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
